import { UniformEmoji } from '@sparemin/text-effects';
import { replaceDynamicKeywordsWithPlaceholders } from 'utils/embed/text-overlay-ts';

export interface FormatTextOptions {
  parseEmojis?: boolean;
  addDynamicTextPlaceholders?: boolean;
}

/**
 * Formats text with consistent rendering across the editors.
 */
export function formatText(
  text: React.ReactNode,
  options?: FormatTextOptions,
): string {
  if (!text) {
    return '';
  }

  const { parseEmojis = true, addDynamicTextPlaceholders = false } =
    options || {};

  let formattedText = text;

  if (parseEmojis) {
    formattedText = UniformEmoji.replaceWithUniformEmoji(String(formattedText))
      ?.output;
  }

  if (addDynamicTextPlaceholders) {
    formattedText = replaceDynamicKeywordsWithPlaceholders(formattedText);
  }

  return String(formattedText);
}
